import React from 'react';
import { WEB_NAVIGATION, trackUserEvent } from 'userActivityMiddleware';
import withEnabledLocations from 'containers/withEnabledLocations';
import GenericDropdown from 'components/GenericDropdown';
import MenuItemLink from 'components/MenuItemLink';
import WCCLogoIcon from 'components/WCCIcon';
import './PropertyDropdown.css';

function PropertyDropdown({ enabledLocations }) {
  const handlePropertyClick = property => {
    trackUserEvent({
      activityType: WEB_NAVIGATION,
      initiator: property.initiator
    });
  };

  return (
    <GenericDropdown
      className="property-sites-menu"
      dropdownId="property-sites-dropdown"
      format="transparent"
      title={<WCCLogoIcon />}
      aria-label="Wind Creek Property List"
      withHover={false}
      withCaret
    >
      <div className="property-sites-dropdown-title">Explore A Casino</div>
      {enabledLocations.map((property, index) => (
        <MenuItemLink
          key={index}
          target="_blank"
          onClick={() => handlePropertyClick(property)}
          {...property}
        />
      ))}
    </GenericDropdown>
  );
}

export default withEnabledLocations(PropertyDropdown);
